<template>
  <div v-if="offices === null" class="flex w-full justify-center p-6">
    <loader />
  </div>
  <div v-else class="container mx-auto">
    <div class="p-3">
      <div class="w-full flex flex-wrap items-stretch -mx-2 -mb-3">
        <div v-for="office in offices.data" :key="office.id" class="w-full md:w-1/2 px-2 mb-3">
          <div class="bg-grey-lighter rounded p-3 h-full flex flex-col">
            <div class="flex flex-grow mb-6">
              <img v-if="office.style && office.style.photo1_url" :src="office.style.photo1_url" class="block w-1/3 object-contain mr-3 rounded" />
              <div v-else class="w-1/3 mr-3 bg-grey-light rounded flex items-center justify-center">
                <i class="fas fa-building text-xl text-grey-dark"></i>
              </div>
              <div class="w-2/3">
                <strong class="block mb-1">{{ office.address_town }} Office</strong>
                <div class="flex flex-col">
                  <span v-if="office.address_name_number">{{ office.address_name_number }}</span>
                  <span v-if="office.address_line2">{{ office.address_line2 }}</span>
                  <span v-if="office.address_line3">{{ office.address_line3 }}</span>
                  <span v-if="office.address_town">{{ office.address_town }}</span>
                  <span v-if="office.address_line4">{{ office.address_line4 }}</span>
                  <span v-if="office.address_postcode">{{ office.address_postcode }}</span>
                </div>
                <div class="flex flex-col mt-3">
                  <div class="whitespace-no-wrap overflow-hidden" v-if="office.sales_phone || office.lettings_phone">
                    <strong>T:</strong> {{ office.sales_phone || office.lettings_phone }}
                  </div>
                  <div class="whitespace-no-wrap overflow-hidden" v-if="office.sales_email || office.lettings_email">
                    <strong>E:</strong> {{ office.sales_email || office.lettings_email }}
                  </div>
                </div>
              </div>
            </div>

            <div class="w-full flex items-stretch -mx-2">
              <div class="w-1/2 px-2">
                <button class="p-3 bg-grey-light hover:bg-grey rounded w-full">
                  Properties For Sale
                </button>
              </div>

              <div class="w-1/2 px-2">
                <button class="p-3 bg-grey bg-grey-light hover:bg-grey rounded h-full w-full">
                  Properties To Let
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapState } from 'vuex'

export default {
  props: {
    value: Object,
    mode: String
  },
  data () {
    return {
      offices: null
    }
  },
  computed: {
    ...mapState(['selectedOffice']),
    content: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  created () {
    this.getOffices()
  },
  methods: {
    getOffices () {
      v2Api.get('office', {
        params: {
          client_id: this.selectedOffice.client_id,
          include_hidden: 0,
          limit: 50
        }
      }).then((response) => {
        this.offices = response.data
      })
    }
  }
}
</script>
